import { render, staticRenderFns } from "./TablePage.vue?vue&type=template&id=3fbb3fc6&scoped=true&"
import script from "./TablePage.vue?vue&type=script&lang=ts&"
export * from "./TablePage.vue?vue&type=script&lang=ts&"
import style0 from "./TablePage.vue?vue&type=style&index=0&id=3fbb3fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbb3fc6",
  null
  
)

export default component.exports